import { useRouter } from 'next/router'
import { useEffectOnce } from 'react-use'

import { useTracking } from 'hooks/useTracking'
import { EVENT_NAMES } from 'lib/tracking'

const PATH_SUBDIRECTORIES_TO_OMIT = ['onboarding', 'configurator']

const ALREADY_TRACKED_SECTIONS_MAP: Record<string, boolean> = {}

type Options = {
	includeIdPath?: boolean
	customIdPathToTrack?: string
}

const useSectionOpenedTracking = (options: Options = {}) => {
	const router = useRouter()
	const track = useTracking()

	useEffectOnce(() => {
		const getSectionNameFromRoute = () => {
			// remove hash from route as we do not want to track it as we do not use them as anchors
			// and it might contain sensitive data (i.e. token)
			const [path] = router.pathname.split('#')
			const getIdPart = () =>
				options.customIdPathToTrack && router.asPath.includes(options.customIdPathToTrack)
					? options.customIdPathToTrack
					: ':id'
			return path
				.replace(/\[\[.*?\]\]/g, options.includeIdPath ? getIdPart() : '')
				.replace(/\[.*?\]/g, options.includeIdPath ? getIdPart() : '')
				.split('/')
				.filter((part) => !PATH_SUBDIRECTORIES_TO_OMIT.includes(part) && part !== '')
				.join('/')
		}

		const sectionName = getSectionNameFromRoute()

		if (ALREADY_TRACKED_SECTIONS_MAP[sectionName]) {
			return
		}

		ALREADY_TRACKED_SECTIONS_MAP[sectionName] = true
		track(EVENT_NAMES.SECTION_OPENED, { sectionName })
	})
}

export default useSectionOpenedTracking
